<script setup lang="ts"></script>

<template>
  <q-card class="sfx-card-manager--skeleton">
    <div class="sfx-card-manager--skeleton-top">
      <q-skeleton width="100%" height="100%" class="sfx-card-manager--skeleton-top-image">
        <q-skeleton
          type="QChip"
          class="absolute-bottom-right q-ma-sm"
          height="24px"
          width="100px"
        />
      </q-skeleton>
    </div>
    <div class="column q-pa-md sfx-card-manager--skeleton-bottom">
      <q-skeleton type="text" class="text-h3" />
      <q-skeleton type="text" class="text-h6 q-mb-md" />

      <div class="row">
        <div class="col-6">
          <q-skeleton type="text" class="text-body1" width="200px" />
          <q-skeleton type="text" class="text-body1" width="200px" />
          <q-skeleton type="text" class="text-body1" width="200px" />
          <q-skeleton type="text" class="text-body1" width="200px" />
        </div>

        <div class="col-6 flex flex-center">
          <q-skeleton type="rect" height="90px" width="225px" />
        </div>
      </div>
    </div>
  </q-card>
</template>
